export default "__VITE_ASSET__B029vx7z__"